import { render, staticRenderFns } from "./SurveyDialog.vue?vue&type=template&id=0aefb895&scoped=true"
import script from "./SurveyDialog.vue?vue&type=script&lang=js"
export * from "./SurveyDialog.vue?vue&type=script&lang=js"
import style0 from "./SurveyDialog.vue?vue&type=style&index=0&id=0aefb895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aefb895",
  null
  
)

export default component.exports